/**
 * Оценка числа SMS-сегментов.
 *
 * Кириллица идёт в UCS-2: 70 символов на 1 сегмент, либо 67 на сегмент в
 * multipart. Латиница без extension-символов — GSM-7: 160 / 153. Простая
 * эвристика: есть хоть один не-ASCII символ → считаем как UCS-2.
 *
 * (Та же логика, что в SendSmsToLeadButton/SendStatusSmsButton — вынесено для
 * переиспользования на странице настроек и в кнопке отчёта.)
 */
export function countSmsSegments(text: string): number {
  if (text.length === 0) return 0
  const isUcs2 = /[^\x00-\x7F]/.test(text)
  if (isUcs2) {
    return text.length <= 70 ? 1 : Math.ceil(text.length / 67)
  }
  return text.length <= 160 ? 1 : Math.ceil(text.length / 153)
}
